<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  .add-button {
    justify-content: flex-start;
  }

  .alias-rows {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }

  .alias-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 8px;
  }

  .email-label {
    flex: 1;
  }

  .account-label {
    flex: 1 1 50%;
    min-width: 0;
    max-width: 50%;
  }

  .alias-row {
    display: flex;
    width: 100%;
    gap: 8px;
    align-items: flex-start;
    margin-bottom: 10px;
  }

  .email-input,
  .account-dropdown {
    flex: 1 1 50%;
    min-width: 0;
    max-width: 50%;
    overflow: hidden;
    padding: 2px;
  }

  .info-text {
    color: colors.get(systemInformation_100);
    font-size: 0.875rem;
    margin-top: utils.in_rem(8px);
    display: flex;
    align-items: center;
    gap: utils.in_rem(8px);
    padding: utils.in_rem(12px);
    border-radius: 6px;
    background-color: colors.get(systemInformation_10);
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import Label from "@sourcewhale/shared/svelte-design-system/components/atoms/InputLabels/Label.svelte";
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import TextInputWithChips from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInputWithChips.svelte";
  import { isValidEmail } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import { teamStore } from "../../../../../api-stores/license-store";
  import { aliasRowsStore } from "../stores";

  const addRow = () => {
    $aliasRowsStore = [...$aliasRowsStore, { email: [], aliasUserId: "" }];
  };
</script>

<div class="alias-rows">
  <div class="alias-header">
    <div class="email-label">
      <Label label="Alias Email Address(es)" />
    </div>
    <div class="account-label">
      <Label label="Main Account" />
    </div>
  </div>

  {#each $aliasRowsStore as row, i}
    <div class="alias-row">
      <div class="email-input">
        <TextInputWithChips
          class="truncate-content"
          bind:chips={$aliasRowsStore[i].email}
          invalidChips={row.email.filter((email) => !isValidEmail(email))}
          placeholder="Type in email addresses"
        />
      </div>

      <div class="account-dropdown">
        <SingleSelectDropdown
          items={$teamStore.users.map((user) => ({
            id: user.userId,
            label: user.email,
          }))}
          bind:selected={$aliasRowsStore[i].aliasUserId}
          placeholder="Select main account"
        />
      </div>
    </div>
  {/each}

  <div class="add-button">
    <Button kind="ghost-blue" leadingIcon="fas fa-plus" onclick={addRow}>
      Add Alias
    </Button>
  </div>

  <div class="info-text">
    <Icon class="fas fa-info-circle" />
    <span>Alias accounts must be linked to a main account</span>
  </div>
</div>
